<template>
	<v-card outlined :disabled="loading">
		<v-card-title>
			{{ dayName }}
			<v-spacer />
			<v-btn fab x-small color="success" v-if="!hasWh" @click="addItem('wh')">
				<v-icon>mdi-plus</v-icon>
			</v-btn>
			<v-btn fab x-small color="success" class="ml-2" v-if="changed" @click="save">
				<v-icon>mdi-check</v-icon>
			</v-btn>
		</v-card-title>

		<v-card-text v-if="hasWh">
			<div class="d-flex align-center justify-space-between">
				<v-icon left>mdi-clock-outline</v-icon>
				<span>{{ getBeginTime(wh[0]) }} - {{ getEndTime(wh[1]) }}</span>
				<v-range-slider v-model="wh" :max="max" :min="min" hide-details />
				<v-btn icon color="error" @click="deleteItem('wh')">
					<v-icon>mdi-delete-outline</v-icon>
				</v-btn>
			</div>

			<div v-if="hasWh" class="d-flex align-center justify-space-between">
				<template v-if="hasLh">
					<v-icon left>mdi-food</v-icon>
					<span>{{ getBeginTime(lh[0]) }} - {{ getEndTime(lh[1]) }}</span>
					<v-range-slider v-model="lh" :max="max" :min="min" hide-details :rules="rules" />
					<v-btn icon color="error" @click="deleteItem('lh')">
						<v-icon>mdi-delete-outline</v-icon>
					</v-btn>
				</template>
				<template v-else>
					<v-icon left>mdi-food</v-icon>
					<v-btn icon color="success" @click="addItem('lh')">
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</template>
			</div>
		</v-card-text>

		<v-overlay absolute :value="loading">
			<v-progress-circular indeterminate size="64" width="2"></v-progress-circular>
		</v-overlay>
	</v-card>
</template>

<script>
import slotsMixin from '~/mixins/slotsMixin'
export default {
	name: 'Day',

	mixins: [slotsMixin],

	props: {
		day: {
			type: Number,
			required: true
		},
		opnhr: {
			type: Object,
			default: Object
		}
	},

	data() {
		return {
			wh: [null, null],
			lh: [null, null],
			hasWh: this._.has(this.opnhr, 'begin_slot') && this.opnhr.time_id !== null,
			hasLh: this._.has(this.opnhr, 'lunch_begin_slot') && this.opnhr.lunch_begin_slot !== null,
			rules: [v => this.wh[0] < v[0] && this.wh[1] > v[1]],
			loading: false
		}
	},

	computed: {
		dayName() {
			return this.$moment()
				.day(this.day)
				.format('dddd')
		},
		changed() {
			let wh = [this.opnhr.begin_slot ?? null, this.opnhr.end_slot ?? null]
			let lh = [this.opnhr.lunch_begin_slot ?? null, this.opnhr.lunch_end_slot ?? null]
			let change = !this._.isEqual(wh, this.wh) || !this._.isEqual(lh, this.lh)
			let lunchCheck = this.lh.join() === ',' || (this.wh[0] < this.lh[0] && this.wh[1] > this.lh[1])
			return change && lunchCheck
		}
	},

	created() {
		if (this.hasWh) {
			this.wh = [this.opnhr.begin_slot, this.opnhr.end_slot]
		}

		if (this.hasLh) {
			this.lh = [this.opnhr.lunch_begin_slot, this.opnhr.lunch_end_slot]
		}
	},

	methods: {
		deleteItem(type) {
			if (type === 'lh') {
				this.lh = [null, null]
				this.hasLh = false
				return
			}
			this.wh = [null, null]
			this.hasWh = false
			this.lh = [null, null]
			this.hasLh = false
		},

		addItem(type) {
			switch (type) {
				case 'wh':
					this.wh = [17, 32]
					this.hasWh = true
					break
				case 'lh':
					this.lh = [25, 25]
					this.hasLh = true
					break
			}
		},

		save() {
			this.loading = true
			if (!this.hasWh) {
				this.removeRec()
			} else {
				this.updateCreateRec(this._.has(this.opnhr, 'id'))
			}
		},

		async updateCreateRec(update) {
			/* let reqData = {
				dayOfWeek: this.day,
				fromId: this.wh[0],
				toId: this.wh[1],
				lunchFromId: this.lh[0],
				lunchToId: this.lh[1]
			} */

			let reqData = {
				dayOfWeek: this.day,
				wh: this.wh,
				lh: this.lh
			}

			if (update) {
				let { data } = await this.$http.put(`opnhr/${this.opnhr.id}`, reqData)
				this.opnhr = data
			} else {
				let { data } = await this.$http.post(`opnhr`, reqData)
				this.opnhr = data
			}
			await this.$store.dispatch('auth/fetchOpnhrs')
			this.loading = false
		},

		async removeRec() {
			await this.$http.delete(`opnhr/${this.opnhr.id}`)
			await this.$store.dispatch('auth/fetchOpnhrs')
			this.opnhr = {}
			this.loading = false
		}
	}
}
</script>

<style lang="scss" scoped></style>
